import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import { IconComponent } from '@shared/components/svg/icon.component';

const base = 'inline-flex items-center rounded-full bg-neutral-100 p-2 disabled:text-neutral-500';
const sizeLg = 'w-12 h-12';
const sizeMd = 'w-10 h-10';
const sizeSm = 'w-8 h-8';

type Size = 'lg' | 'md' | 'sm';

const buildTwClasses = (className: string, size: Size = 'md'): string =>
  `${className} ${base} ${size === 'lg' ? sizeLg : size === 'md' ? sizeMd : sizeSm}`;

@Directive({
  selector: '[app-icon-button]',
  exportAs: 'appIconButton'
})
export class IconButtonDirective implements OnChanges {
  @HostBinding('class')
  private twClasses = buildTwClasses(this.element.nativeElement.className);

  @Input() name: string = '';
  @Input() size: Size = 'md';

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.name) {
      let iconSize = 24;
      if (this.size === 'lg') iconSize = 32;
      else if (this.size === 'sm') iconSize = 16;

      const iconRef = this.viewContainerRef.createComponent(IconComponent);
      iconRef.setInput('name', this.name);
      iconRef.setInput('fontSize', iconSize);

      const iconEl = iconRef.location.nativeElement;
      iconEl.classList.add('leading-none');
      this.renderer.appendChild(this.element.nativeElement, iconEl);

      this.twClasses = buildTwClasses(this.element.nativeElement.className, this.size);

      this.cdr.markForCheck();
    }
  }
}
